import PropTypes from "prop-types";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import styles from "./index.css";
import { decodeAndSortUrl } from "../../helpers/decodeAndSortUrl";
import { shouldRenderPagination } from "../../state/selectors";
import {
  getPaginationInitial,
  getPaginationMax,
} from "../../state/modules/search";
import { getCanonicalUrlFromCategoryDetailsByLocale } from "../../state/modules/category/selectors";
import { withTranslation } from "../translation";

const range = (start, end) =>
  Array(end - start + 1)
    .fill()
    .map((_, index) => start + index);

const MAX_LINKS = 20;

const PaginationContent = ({ formatTranslation }) => {
  const shouldRender = useSelector(shouldRenderPagination);
  const currentPage = useSelector(getPaginationInitial);
  const maxPage = useSelector(getPaginationMax);
  const url = useSelector(getCanonicalUrlFromCategoryDetailsByLocale);

  const pages = useMemo(() => {
    if (maxPage <= 1) {
      return [];
    }

    const start = Math.max(1, currentPage - Math.floor(MAX_LINKS / 2));
    const end = Math.min(maxPage, currentPage + Math.floor(MAX_LINKS / 2));
    const adjustedStart = Math.max(2, end - MAX_LINKS);
    const adjustedEnd = Math.min(maxPage, start + MAX_LINKS);

    const pageRange = range(adjustedStart, adjustedEnd).filter(
      (page) => page !== currentPage,
    );

    return currentPage === 1 ? pageRange : [1, ...pageRange];
  }, [currentPage, maxPage]);

  if (!shouldRender) {
    return null;
  }

  return (
    <div className={styles.paginationLinks} data-nosnippet>
      {pages.map((page) => (
        <a
          key={page}
          href={decodeAndSortUrl(`${url}${page === 1 ? "" : `&page=${page}`}`)}
        >
          {`${formatTranslation("plp_web_category_page")} ${page}`}
        </a>
      ))}
    </div>
  );
};

PaginationContent.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
};

export { PaginationContent };

export default withTranslation(PaginationContent);
